var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_4371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.70898 0.441406L1.83398 2.31641L4.95898 5.44141L1.83398 8.56641L3.70898 10.4414L8.70898 5.44141L3.70898 0.441406Z",
    fill: "#1F2024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_4371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.583984 0.441406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextActiveIcon);
export default __webpack_public_path__ + "static/media/nextActiveIcon.a0db27b2789215faf0519ad3ea01be07.svg";
export { ForwardRef as ReactComponent };